export default {
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: '服务名称',
    companyName: '销售业者',
    representative: '代表者姓名',
    address: '所在地',
    contact: '咨询处',
    paymentTerms: '付款方式及付款时间',
    deliverySchedule: '商品交付时间',
    sellingPrice: '商品等的销售价格',
    shippingFee: '运费',
    additionalFee: '销售价格・运费等以外的必要费用',
    salesRestrictions: '销售期间・销售数量的限制',
    returnsAndCancellations: '退货・取消',
    otherConditions: '其他条件'
  }
};
